import React from 'react';
import SignUpForm from '../forms/SignUpForm';

function SignUp() {
    return (
        <div>
            <SignUpForm />
        </div>
    );
}

export default SignUp;